import {  useEffect, useState } from 'react';
import { ConfigProvider, } from 'antd';


// redux
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../Redux/hooks";
import { setSelected,setOpenDeleteSpace} from "../../store/rmboxActions";
import UseActionMenu from "./actionUserTable";
import frFR from 'antd/lib/locale/fr_FR';
import { Datagrid } from '@empreinte/components.datagrid';
import { useTranslation } from "react-i18next";
import {GridNorows} from '@empreinte/components.grid-norows';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { useMediaQuery } from '@mui/material';
import Hooks from "../../utils/hooks"; 
moment.locale('en');


const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

function useDataTableMedia({ columns, dataSource, updateEntityPath }: any) {
    const { t } = useTranslation();

    const { handelSearch,getAllData,refreshRmbox } = Hooks()
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);

    const [selectedRow] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState<any>(DEFAULT_PAGE_NUMBER);
    const [pageSize,setPageSize] = useState<any>(DEFAULT_PAGE_SIZE);
   const totalength = useAppSelector((state)=>state.RmboxReducer.totalRecord)
    const [locale] = useState<any>(frFR);
    const tabletColumn = useMediaQuery('(min-width:780px)');
    const mobileColumn = useMediaQuery('(min-width:550px)');
    //const [actionColumnView] = useActionMenuTable({ selectedRow, updateEntityPath , record });

    // use Selector redux
    const values = useAppSelector((state) => state.RmboxReducer.filterRmbox)
    const searchWord= values.search
    const statusDel = useAppSelector((state)=>state.RmboxReducer.statusDel)

        useEffect(() => { 
            // Check if there is no data on the current page
            if (currentPage > 1 && dataSource.length === 0) {
              setCurrentPage(1); // Assuming you have a state variable 'setCurrentPage' to update the page
            }
            //eslint-disable-next-line react-hooks/exhaustive-deps
          }, [currentPage, dataSource]);

          
        useEffect(()=>{
        if(searchWord)

        refreshRmbox()
            //eslint-disable-next-line react-hooks/exhaustive-deps
        },[searchWord])

        useEffect(()=>{
            if(statusDel){
                setCurrentPage(1)
            }else{
                getAllData(currentPage,pageSize,searchWord)
            }
            //eslint-disable-next-line react-hooks/exhaustive-deps
         },[currentPage,pageSize,totalength,statusDel])

    //const history = useNavigate();
    const dispatch = useDispatch();


    const updatedColumns = [
        ...columns,
        {
            title: <label className="titlecolumn">{t('Rmbox.actions')}</label>,
            // key: 'action',
            key:4,
            flex:1,
            field:t('Rmbox.actions'),
            renderCell: (action: any, record: any) => {
                return (
                    <UseActionMenu record={action} />
                )
            },
            className:"contentcolumn",
            width:"35%",
            align: "start",

        },
    ];
    const filteredevents = handelSearch(values.search, dataSource)
    const resetPagination = () => {
        setCurrentPage(DEFAULT_PAGE_NUMBER);
    };

    function getFilteredEvents(filteredEvents:any, e:any) {
        let tab = filteredEvents.filter((item:any) => {
          return e.includes(item.id);
        });
        let newArray = Array.from(tab, (item:any) => {
          return item.id;
        });
        return newArray;
      }

    const DataTable = () => (
        <div className="DataTable">
            <ConfigProvider locale={locale}>
            {!totalength || !filteredevents.length?
                 <GridNorows content={t('Zone.noRowsFound')} />
                :
                <Datagrid
                className={"DataTable__custom-row"}
                height={"calc(90vh - 100px)"}
                selectionModel={selectedRowKeys}
                totalEntities={totalength}
                checkboxSelection={true}
                checkboxSelect={e => {
                    let newArray = getFilteredEvents(filteredevents, e);
                    setSelectedRowKeys(e);
                    dispatch(setSelected(newArray));
                    dispatch(setOpenDeleteSpace(newArray.length > 0));
 
                    dispatch(setSelected(newArray));
                }}
                columns={
                    tabletColumn
                      ? updatedColumns
                      : mobileColumn
                        ?  
                          updatedColumns.filter(
                            column =>
                              column.dataIndex !== 'group'
                          ):
                           updatedColumns.filter(
                            column =>
                              column.dataIndex !== 'group' &&
                              column.dataIndex !== 'programs'
                          ).filter(
                            column =>
                              column.dataIndex !== 'group' &&
                              column.dataIndex !== 'programs' &&
                              column.dataIndex !== 'ip'
                          )
                  }
                // columns={updatedColumns}
                rows={dataSource && filteredevents}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                setPageSize={setPageSize}
                pageSize={pageSize}
                ShowName={t('boitier.AuthorizedIP.rows')}
                EntriesName={t('boitier.AuthorizedIP.element')}
                OfPageName={t('boitier.AuthorizedIP.of')}
                />}
            </ConfigProvider>
        </div>
    );

    return {
        DataTable,
        selectedRow,
        selectedRowKeys,
        currentPage,
        pageSize,
        resetPagination,
    };
}

export default useDataTableMedia;
